import Icon from "@components/_Revamp/Icon/Icon";
import React, { HTMLAttributes } from "react";
import { styled } from "@linaria/react";
import { ROUTE_PATH } from "@static/route-paths";
import { Link, useLocation } from "react-router-dom";
import { CONTAINER_SIZE, SCREEN_SIZE } from "@static/screen-size";
import { Stepper } from "./Stepper";
import { Step } from "../Stepper/Stepper";
import { useScreenSize } from "@pages/CCP/Hooks/useScreenSize";

interface IContainerWithBackButton extends HTMLAttributes<HTMLDivElement> {
  backButtonFunction?: React.MouseEventHandler | null;
  backButtonPath?: string;
  step?: number;
  pathsNotToShowProductOverview?: string[];
  stepList: Step[];
}

export default function HealthMainContainer({
  backButtonPath,
  children,
  step,
  backButtonFunction,
  stepList = [],
  pathsNotToShowProductOverview,
  className,
}: React.PropsWithChildren<IContainerWithBackButton>) {
  const location = useLocation();
  const currentPath: string | any = location.pathname;
  const currentPathTrimmed = currentPath?.endsWith("/")
    ? currentPath?.slice(0, -1)
    : currentPath || "";
  const enableProductOverView =
    !pathsNotToShowProductOverview?.includes(currentPathTrimmed);
  const { isMobile } = useScreenSize();

  const stepIndex = step && step > 0 && step <= stepList.length ? step - 1 : 0;
  return (
    <div style={{ marginTop: isMobile && stepList.length ? 96 : 0 }}>
      <Container
        noStepper={step ? false : true}
        showProductView={enableProductOverView}
        className={className}
        isPadding={Boolean(isMobile && stepList.length)}
      >
        {(backButtonPath || backButtonFunction) && (
          <BackButton className="bck-btn">
            {backButtonPath && (
              <Link
                to={backButtonPath}
                style={{ color: "#000000", fontWeight: 600, fontSize: "16px" }}
              >
                <Icon name="back-arrow"></Icon> Back
              </Link>
            )}
            {backButtonFunction && (
              <span
                onClick={backButtonFunction}
                style={{
                  color: "#000000",
                  fontWeight: 600,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "10px",
                  fontSize: "16px",
                }}
              >
                <Icon name="back-arrow"></Icon> Back
              </span>
            )}
          </BackButton>
        )}
        {children}
      </Container>
      {stepList?.length ? (
        <Stepper
          steps={stepList}
          backgroundColor="transparent"
          bulletColor="none"
        ></Stepper>
      ) : null}
    </div>
  );
}

const BackButton = styled.div`
  margin-bottom: 24px;
  a {
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 10px;
    width: fit-content;
  }
  @media (min-width: ${SCREEN_SIZE.mobileSteper}px) {
    margin-bottom: 64px;
  }
`;

const Container = styled.div<{
  noStepper?: boolean;
  showProductView?: boolean;
  isPadding?: boolean;
}>`
  position: relative;
  margin: 0 auto;
  display: block;
  flex-wrap: wrap;
  margin-top: ${({ noStepper }) => (noStepper ? "0" : "98px")};
  padding: ${({ isPadding }) => (isPadding ? "24px" : "0 24px 24px 24px")};
  color: #434343;
  margin-bottom: ${({ showProductView }) => (showProductView ? "125px" : "0")};
  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    max-width: ${CONTAINER_SIZE.desktops}px;
    margin-top: ${({ noStepper }) => (noStepper ? "24px" : "124PX")};
    margin-bottom: 0;
  }

  @media screen and (min-width: 1055px) {
    .bck-btn {
      position: absolute;
      left: -160px;
    }
  }

  @media (min-width: ${SCREEN_SIZE.mobileSteper}px) {
    margin-top: 64px;
  }
`;
